import { Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useEffect, useState } from 'react';
import { TabEnvios } from './components/TabEnvios';
import { TabDashboardEnvios } from './components/TabDashboardEnvios/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faTruck } from '@fortawesome/free-solid-svg-icons';
import { ENVIOS_API } from '../shared/services/envios';
import { toast } from 'react-toastify';
import InfoModal from '../shared/components/InfoModal';
import EnvioDetalleModal from './components/EnviosMetrics/components/EnvioDetalleModal';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchEmailsNoSent,
    fetchEnviosNoGenerated,
    resetShippingResults,
} from '../../../../redux/envios';
import TabAlertasEnvios from './components/TabAlertasEnvios';
import EmailsNoSent from './components/EmailsNoSent';

export default function Envios() {
    const [tab, setTab] = useState('dashboard');
    const [totalNoGenerated, setTotalNoGenerated] = useState({
        shipping: 0,
        email: 0,
    });
    const [isNoGeneratedOpen, setIsNoGeneratedOpen] = useState(false);
    const [isFirstOpen, setIsFirstOpen] = useState(false);
    const dispatch = useDispatch();
    const loading = useSelector((state) => {
        return state.loading;
    });
    const shippingResults = useSelector((state) => {
        return state.envios.shippingResults;
    });

    const handleChangeTab = (_e, tab) => setTab(tab);

    const getTotalNoGenerated = async () => {
        try {
            const res = await ENVIOS_API.getNoGeneratedCount();
            if (res?.success) {
                return setTotalNoGenerated({
                    shipping: res.data.total_pendientes_envio,
                    email: res.data.total_pendientes_email,
                });
            }
            toast.error('No se han podido obtener los envios no generados!');
        } catch (e) {
            toast.error(e.message);
        }
    };

    const handleOpenNoEmailSent = () => {
        if(totalNoGenerated.email === 0) {
            return
        }
        dispatch(fetchEmailsNoSent());
        setIsFirstOpen('email');
    };

    const handleOpenNoGenerated = () => {
        if(totalNoGenerated.shipping === 0) {
            return
        }
        dispatch(fetchEnviosNoGenerated(1));
        setIsFirstOpen('shipping');
    };

    const handleCloseNoGenerated = () => {
        setIsFirstOpen(false);
        setIsNoGeneratedOpen(false);
        dispatch(resetShippingResults());
        getTotalNoGenerated();
    };

    const getNoGeneratedNewPage = (newPage) => {
        dispatch(fetchEnviosNoGenerated(newPage));
    };

    useEffect(() => {
        getTotalNoGenerated();

        const interval = setInterval(() => {
            getTotalNoGenerated();
        }, 1800000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!isNoGeneratedOpen && isFirstOpen && !loading) {
            setIsNoGeneratedOpen(isFirstOpen);
        }
    }, [isNoGeneratedOpen, loading, isFirstOpen]);

    return (
        <div className="content pt-3">
            <span
                className="notification-icon notification-email-provider"
                title="Proveedores pendientes de notificar"
                style={{ cursor: totalNoGenerated.email === 0 ? 'default' : 'pointer' }}
                onClick={handleOpenNoEmailSent}
            >
                <FontAwesomeIcon
                    className="notification-menu"
                    icon={faEnvelope}
                    size="2x"
                    color="#215732"
                />
                <span className="notification-number">
                    {totalNoGenerated.email}
                </span>
            </span>
            <span
                className="notification-icon notification-shipping-truck"
                title="Envíos pendientes de generar"
                style={{ cursor: totalNoGenerated.shipping === 0 ? 'default' : 'pointer' }}
                onClick={handleOpenNoGenerated}
            >
                <FontAwesomeIcon
                    className="notification-menu"
                    icon={faTruck}
                    size="2x"
                    color="#215732"
                />
                <span className="notification-number">
                    {totalNoGenerated.shipping}
                </span>
            </span>
            <TabContext value={tab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChangeTab} aria-label="Ajustes">
                        <Tab label="General" value="dashboard" />
                        <Tab label="Alertas" value="alertas" />
                        <Tab label="Envios" value="envios" />
                    </TabList>
                </Box>
                <TabPanel value="dashboard">
                    <TabDashboardEnvios
                        updateNoGeneratedTotal={getTotalNoGenerated}
                    />
                </TabPanel>
                <TabPanel value="alertas">
                    <TabAlertasEnvios />
                </TabPanel>
                <TabPanel value="envios">
                    <TabEnvios />
                </TabPanel>
            </TabContext>
            {isNoGeneratedOpen === 'shipping' && (
                <InfoModal
                    state={isNoGeneratedOpen}
                    title="Envíos no generados"
                    width={'lg'}
                    content={
                        <EnvioDetalleModal
                            getShippingNewPage={getNoGeneratedNewPage}
                            shippingResults={shippingResults}
                        />
                    }
                    onClose={handleCloseNoGenerated}
                />
            )}
            {isNoGeneratedOpen === 'email' && (
                <InfoModal
                    state={isNoGeneratedOpen}
                    title="Emails no enviados al proveedor"
                    width={'lg'}
                    content={
                        <EmailsNoSent
                            results={shippingResults}
                        />
                    }
                    onClose={handleCloseNoGenerated}
                />
            )}
        </div>
    );
}
